import { z } from "zod";

// Skema untuk anak-anak (detail per properti)
const ReportAgentChildV4Schema = z.object({
    property: z.string(), // Menggunakan "property" sesuai data API terbaru
    room_nights: z.number().int(),
    reservations: z.number().int(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number().int(),
});

// Skema untuk data utama per agen
const ReportAgentDataV4Schema = z.object({
    agent_name: z.string(),
    color: z.string().nullable().optional(),
    percentage: z.string(), // Perbaikan: Tipe adalah string di data utama
    room_nights: z.number().int(),
    reservations: z.number().int(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number().int(),
    children: z.array(ReportAgentChildV4Schema),
});

// Skema untuk objek total
const ReportAgentTotalV4Schema = z.object({
    percentage: z.number(), // Perbaikan: Tipe adalah number di objek total
    room_nights: z.number().int(),
    reservations: z.number().int(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number().int(),
});

// Skema respons API utama
export const ReportAgentResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(ReportAgentDataV4Schema),
    total: ReportAgentTotalV4Schema,
});

export type ReportAgentDataV4Response = z.infer<typeof ReportAgentDataV4Schema>;
export type ReportAgentResponseV4 = z.infer<typeof ReportAgentResponseV4Schema>;